import { GoogleTagManager } from '@next/third-parties/google'
import { AppProps, NextWebVitalsMetric } from 'next/app'
import NextProgressBar from 'nextjs-progressbar'
import { FC } from 'react'
import { Provider } from 'react-redux'
import Metas from 'src/components/Metas'
import Tooltips from 'src/components/Tooltips'
import 'src/helpers/BugsnagHelpers'
import I18nProvider from 'src/i18n/Provider'
import { PersistWrapper } from 'src/redux/persist'
import reduxStore from 'src/redux/store'
import { PageProps } from 'src/relay/Common/PageProps'
import ReduxInit from 'src/relay/ReduxInit'
import { colors, GlobalStyles, themes } from 'src/theme'
import { ThemeProvider } from 'styled-components'
import Head from 'next/head'
import { fontsPreload } from 'src/theme/fonts'

import NotFoundPage from './404'

const { store, persistor } = reduxStore

const Application: FC<AppProps<PageProps>> = ({ Component, ...rest }) => {
  const JSCComponent = Component as FC<PageProps>
  const pageProps: PageProps = rest?.pageProps

  return (
    <>
      {process.env.NEXT_PUBLIC_GTM_ID && (
        <GoogleTagManager gtmId={process.env.NEXT_PUBLIC_GTM_ID} />
      )}
      <GlobalStyles />
      <Head>{fontsPreload()}</Head>
      <Provider store={store}>
        <PersistWrapper persistor={persistor}>
          <ReduxInit />
          <I18nProvider store={pageProps?.i18n}>
            <ThemeProvider theme={themes['theme']}>
              <Metas {...pageProps?.metas} />
              {Array.isArray(pageProps?.configuration?.lexicons) && (
                <Tooltips lexicons={pageProps.configuration.lexicons} />
              )}
              <NextProgressBar
                color={colors.bordeaux}
                height={2}
                options={{ showSpinner: false }}
              />
              {(rest as any)?.error ? (
                <NotFoundPage {...pageProps} />
              ) : (
                <JSCComponent {...pageProps} />
              )}
            </ThemeProvider>
          </I18nProvider>
        </PersistWrapper>
      </Provider>
    </>
  )
}

export function reportWebVitals(metric: NextWebVitalsMetric) {
  console.info(metric) // The metric object ({ id, name, startTime, value, label }) is logged to the console

  /*ga('send', 'event', {
      eventCategory:
        metric.label === 'web-vital' ? 'Web Vitals' : 'Next.js custom metric',
      eventAction: name,
      eventValue: Math.round(
        metric.name === 'CLS' ? metric.value * 1000 : metric.value
      ), // values must be integers
      eventLabel: metric.id, // id unique to current page load
      nonInteraction: true, // avoids affecting bounce rate.
    })*/
}

export default Application
